__webpack_require__.p = "https://staging.wishliz.com/";